import React, {useState, useEffect, useRef} from 'react';
import "../../../css/headermenu.scss";
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import {Modal} from "react-bootstrap";
import blackCancelButton from '../../../images/blackCancelButton.png';
import APICall from '../../actions/apicall';
import Submit from './Submit';

function HeaderMenu(props) {
    const history = useHistory();
    const buttonElement = useRef();
    const modalRef = useRef();
    const addBusiness = true;
    const closeMenu = false;
    const [logOutText, setLogOutText] = useState('Log out');
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    let accessToken = Cookies.get('access_token') ?? null;
    let userId = Cookies.get('rs11_user_id') ?? 0;
    
    const handleLogout = () => {
        setLogOutText('Logging Out...');
        window.dataLayer.push({'event': 'logout'});
        
        buttonElement.current.style.pointerEvents = 'none';
        APICall.LogOut((response) => {
            if (response.status == 200 && response.data.status == 'success') {
                if (window.location.href.includes('map')) {
                    window.location.reload();
                }
                else {
                    history.push({
                        pathname: '/map',
                    });
                }
                props.closeHeaderMenu(closeMenu)
            }
            else {
                setErrorMessage(response.data.message);
                setShowError(true);
            }
        });
    }

    const handleClickOutside = (event) => {
        if (modalRef.current) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                props.closeHeaderMenu(closeMenu)
            }
        }
    };

    useEffect(() => {
        // Attach the event listener on mount
        document.addEventListener('click', handleClickOutside, true);
        
        // Clean up the event listener on unmount
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const handleSearch = () => {
        window.dataLayer.push({'event': 'menu_search'});
        history.push('/');
        props.closeHeaderMenu(closeMenu);
    }

    const handleAboutUs = () => {
        history.push('/about-us');
        props.closeHeaderMenu(closeMenu);
    }

    const handleRS11Foundation = () => {
        history.push('/rs11-foundation');
        props.closeHeaderMenu(closeMenu);
    }

    const handleAccountSettings = () => {
        history.push('account-settings');
        props.closeHeaderMenu(closeMenu);
    }

    const handleAddBusiness = () => {
        window.dataLayer.push({'event': 'add_business_start', 'addBusinessTriggeredFrom': 'menu'});
        props.closeHeaderMenu(addBusiness);
    }


    return(
        <div>
            <Modal className="modal left fade menu" show={true} backdrop="static">
                <Modal.Body ref={modalRef}>
                    <div className='menu-side-sheet'>
                        <div className='cancel-top'>
                            <img className='cancel-button' src={blackCancelButton} onClick={() => props.closeHeaderMenu(closeMenu)} />
                        </div>
                        <div className='content-menu'>
                            <div className='menu-options'>
                                <p className='search-text' onClick={handleSearch}>Search</p>
                                {
                                    (accessToken != null) && (<p onClick={handleAddBusiness}>Add a Business</p>)
                                }
                            </div>
                            <div className='menu-options'>
                                <p onClick={handleAboutUs}>About Us</p>
                                <p onClick={handleRS11Foundation}>RS11 Foundation</p>
                            </div>
                            {
                                (accessToken != null) && (
                                <p className='settings-text' onClick={handleAccountSettings}>Account Settings</p>)
                            }
                        </div>
                        {
                            (showError) && (
                            <p className='error-text'>{errorMessage}</p>)
                        }
                        {
                            (accessToken != null) && (
                            <div ref={buttonElement} className='button-class'>
                                <Submit actionText={logOutText} callFunction={handleLogout} disable={logOutText != 'Log out' && true} />
                            </div>)
                        }
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default HeaderMenu;
